<script>
    import {PATH_PREFIX} from '../../../../apiUrls.js';
  import {sgettext} from '../../../../i18n.js';

  export let row = null;
</script>

{#if row.has_access}

<div class="btn-group pr-1">
  <button type="button" class="btn dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class="fa fa-ellipsis-v"></i>
  </button>
  <div class="dropdown-menu">
      <a class="dropdown-item" href={`${PATH_PREFIX}/sw/builder/activity_sequence_builder/${row.activity_version.id}/worksequence/${row.id}/`} target="_blank" rel="noopener noreferrer">{sgettext('$$OPEN_SPATIAL_EDITOR$$')}</a>
<!--      <a class="dropdown-item" href="#">Open in Content Editor</a>-->
  </div>
</div>

{/if}
